import { useMemo } from 'react';
import useLocale from './useLocale';
import { getNamespace, tKey } from '../content';

/** Shell strings (nav, footer, cookie banner, contact, FAQ, 404). */
export function useCommonContent(langProp) {
  const routeLang = useLocale();
  const lang = langProp || routeLang;
  const common = useMemo(() => getNamespace('common', lang) || {}, [lang]);

  const t = useMemo(() => {
    return (key, _ignored = '') => {
      const value = common[key];
      if (value != null && value !== '') return value;
      return tKey('common', key, lang);
    };
  }, [common, lang]);

  const labels = useMemo(() => {
    const map = {
      home: t('nav.home'),
      services: t('nav.services'),
      allServices: t('nav.allServices'),
      aica: t('nav.aica'),
      webDesign: t('nav.webDesign'),
      shopify: t('nav.shopify'),
      about: t('nav.about'),
      blog: t('nav.blog'),
      contact: t('nav.contact'),
      quote: t('nav.quote'),
      freeQuote: t('nav.freeQuote'),
      footerCtaTitle: t('footer.ctaTitle'),
      footerCtaSub: t('footer.ctaSub'),
      footerTagline: t('footer.tagline'),
      company: t('footer.company'),
      support: t('footer.support'),
      newsletter: t('footer.newsletter'),
      emailPlaceholder: t('footer.emailPlaceholder'),
      subscribed: t('footer.subscribed'),
      sending: t('footer.sending'),
      subscribe: t('footer.subscribe'),
      unsubscribe: t('footer.unsubscribe'),
      privacy: t('footer.privacy'),
      terms: t('footer.terms'),
      serviceContract: t('footer.serviceContract'),
      contactUs: t('footer.contactUs'),
      sitemap: t('footer.sitemap'),
      webDesignFooter: t('footer.webDesign'),
      googleAds: t('footer.googleAds'),
      errorRetry: t('footer.errorRetry'),
      connectionError: t('footer.connectionError'),
    };
    return map;
  }, [t]);

  return { content: { strings: common }, lang, t, labels, isEn: lang === 'en' };
}

export default useCommonContent;
